module.exports = __webpack_public_path__ + "img/zjjl.ed0e4260.png";